// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';

type ProviderAccessStatusCardProps = Readonly<{
  icon: React.ReactNode;
  title: string;
  message: string | React.ReactNode;
}>;

/**
 * Shared white card for Provider Access status/error pages.
 * Renders a centered card with icon, title, and message.
 */
export function ProviderAccessStatusCard({
  icon,
  title,
  message,
}: ProviderAccessStatusCardProps) {
  return (
    <div className="flex w-[664px] p-xxl flex-col justify-center items-center gap-md rounded-card bg-white">
      {icon}
      <div className="text-black font-sans text-h2 font-normal leading-normal text-center">
        {title}
      </div>
      <div className="text-black font-sans text-body-01 font-normal leading-normal text-center">
        {message}
      </div>
    </div>
  );
}
